export async function compressImage(file, maxSide = 1600, quality = 0.7) {
  const bitmap = await createImageBitmap(file).catch(() => null);
  const img = bitmap || (await loadImg(file));
  const w = img.width, h = img.height;
  const scale = Math.min(1, maxSide / Math.max(w, h));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(w * scale);
  canvas.height = Math.round(h * scale);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  if (bitmap) bitmap.close();
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
  return new File([blob], "photo.jpg", { type: "image/jpeg" });
}

function loadImg(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const im = new Image();
    im.onload = () => { URL.revokeObjectURL(url); resolve(im); };
    im.onerror = reject;
    im.src = url;
  });
}
